
import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { DisplayLink } from 'ui';

interface FactLinkProps {
  classNames?: string;
  section?: number;
  url?: string;
  children?: React.ReactNode;
  id?: string;
  urlOpenNew?: boolean;
}

export const FactLink: React.FC<FactLinkProps> = ({ id, classNames = '', section, children, url, urlOpenNew }) => {
  const className = `${classNames} fact-link`;
  const linkTo = section || url ? navigate.toSectionURL(section, url) : undefined;

  return (
    <DisplayLink componentId={id} className={className} url={linkTo} urlOpenNew={urlOpenNew} section={section} 
      navigateToUrlForNewTab={!!url}>
      {children}
    </DisplayLink>
  );
};
